export default "__VITE_ASSET__0256b19c__"